import { h } from '@stencil/core';
import { i18n } from 'i18n';
import termsAndConditions from 'store/termsAndConditions';
import { triggerResize } from 'utils/ui';
import initParams from 'store/initParams';

interface TermsButtons {
  size?: 'md' | 'lg';
}

export default function TermsButtons({ size = 'md' }: TermsButtons) {
  const onAccept = () => {
    termsAndConditions.accepted = true;
    triggerResize();
  };

  const onCancel = () => {
    window.document.dispatchEvent(new CustomEvent('chat-assistance-floating-toggle'));
  };

  return (
    <div class="chat-terms-and-conditions-buttons-container">
      <button type="button" class={`eva-3-btn -${size} -primary`} onClick={onAccept}>
        <em class="btn-text">{i18n.t.legal.termsAndConditions.button}</em>
      </button>

      {initParams.mode !== 'FULL_SCREEN' && (
        <button type="button" class={`eva-3-btn -${size} -link`} onClick={onCancel}>
          <em class="btn-text">{i18n.t.legal.termsAndConditions.rejectButton}</em>
        </button>
      )}
    </div>
  );
}
